var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.1c53f6d69d3bf1f5c674add7edc46baf.svg#p';
                    var viewUrl = 'sprites.1c53f6d69d3bf1f5c674add7edc46baf.svg#view-p';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 15 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };